import React, { Fragment } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { useInfiniteQuery, useQuery } from 'react-query';

import { MainContainer, TitleContainer, ColumnContainer, Column, Paragraph, SectionTitle, Breadcrumbs, HeadSeo, Divider } from '@beacharound/beacharound-ui';

import PlacesSearchHeader from '../../components/SearchHeaders/PlacesSearchHeader';
import ActivitiesList from '../../components/Activities/ActivitiesList';

import { getBeaches } from '../../api/beach';
import { getService } from '../../api/services';
import { getDescription, getSubtitle, getTitle, getMetaDescription } from '../../helpers/seo/services';
import NotFoundRedirect from '../../components/NotFound/NotFoundRedirect';
import { getPlaceholderImage } from '../../helpers/images/getPlaceholderImage';

export default function BeachesServiceDetail({match, history}) {
    
    const { serviceSeoSlug } = match.params;
    const serviceSlug = serviceSeoSlug.replace("prenota-un-ombrellone-nelle-migliori-spiagge-", '');

    const { data: service, isLoading, error } = useQuery(["servizi", serviceSlug], () =>
        getService({ slug: serviceSlug })
    );
    
    const elementLimit = 20;

    let beachesOptions = {
        limit: elementLimit,
        maxDistance: true,
        services: [serviceSlug]
    };

    const {
        data: infiniteData,
        fetchNextPage,
        hasNextPage,
        isFetchingNextPage,
    } = useInfiniteQuery(
        ["beaches", beachesOptions],
        ({pageParam = 0}) => {
            return getBeaches({ params: {...beachesOptions, skip: pageParam} })
        },
        {
            getNextPageParam: (lastPage, pages) => {
                if(lastPage.length < elementLimit) { return }
                return lastPage.length > 0 && elementLimit * pages.length;
            }
        }
    );

    const beaches = [...(infiniteData?.pages?.reduce((acc, page) => page && Array.isArray(page) ? [...acc, ...page] : acc, []) || [])];

    const beachesList = beaches?.map((beach) => {
        return {
            ...beach,
            description: undefined,
            component: Link,
            to: `/spiagge/${beach.slugCity || beach.slug}`
        }
    })

    const category = service?.categories && service?.categories[0];

    if (!isLoading && (!service || service?.length === 0)) {
        return <Redirect to={`/404`} />
    }

    return (
        <Fragment>

            <NotFoundRedirect error={error} />

            <HeadSeo
                title={[getTitle(`con ${service?.name}`)]}
                description={getMetaDescription(`con ${service?.name}`)}
                image={getPlaceholderImage(category)}
            />

            <PlacesSearchHeader
                history={history}
                title={getTitle(`con ${service?.name}`)}
                cover={getPlaceholderImage(category)}
                withBeaches={service?.searchParams}
            />

            <MainContainer>
                <ColumnContainer noMargin>
                    <Column>
                        <TitleContainer>
                            <Breadcrumbs
                                fullUrl={match.url}
                                names={service && ["servizi", service.name]}
                                linkComponent={Link}
                            />
                        </TitleContainer>
                    </Column>
                </ColumnContainer>
            </MainContainer>

            <MainContainer>
                <ActivitiesList
                    inlineCards
                    type="beaches"
                    data={beachesList}
                    fetchMore={fetchNextPage}
                    hasMore={hasNextPage}
                    isLoadingMore={isFetchingNextPage}
                />

                <Divider/>

                <ColumnContainer>
                    <Column>
                        <TitleContainer noMargin>
                            <SectionTitle text={getSubtitle(`con ${service?.name}`)} component="h2"/>
                            <Paragraph text={getDescription(`con ${service?.name}`)} />
                        </TitleContainer>
                    </Column>
                </ColumnContainer>
            </MainContainer>
        </Fragment>
    );
}

                        
     